export default __webpack_public_path__ + "static/media/img9.40da0fb1.jpg";